/* Translated: skip */
export default {
  computed: {
    timelineSteps() {
      let step = 1;
      if (this.$route.name === 'accomodation list') {
        step = 1;
      } else if (this.$route.name === 'confirm-accomodation') {
        step = 2;
      } else if (this.$route.name === 'addons') {
        step = 3;
      } else if (this.$route.name === 'shopping cart') {
        step = 4;
      }

      const confirmedAccomodations = (
        this.$store.state.cart
        .accomodations.filter(a => a.confirmed)
        .length
      );

      const objects = [{
        title: 'Våra boenden',
        complete: (step >= 1 ? (step > 1 ? 2 : 1) : 0), // eslint-disable-line no-nested-ternary
        url: { name: 'accomodation list' },
      }, {
        title: 'Boende',
        complete: (step >= 2 ? (step > 2 ? 2 : 1) : 0), // eslint-disable-line no-nested-ternary
        url: { name: 'confirm-accomodation', query: { no: this.accomodationIndex } },
        clickable: confirmedAccomodations,
      }, {
        title: 'Tillval',
        complete: (step >= 3 ? (step > 3 ? 2 : 1) : 0), // eslint-disable-line no-nested-ternary
        url: { name: 'addons', query: { no: this.accomodationIndex } },
        clickable: confirmedAccomodations,
      }, {
        title: 'Betalning',
        complete: (step >= 4 ? (step > 4 ? 2 : 1) : 0), // eslint-disable-line no-nested-ternary
        url: { name: 'shopping cart' },
        clickable: confirmedAccomodations,
      }];

      return objects;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/accomodationTimelineSteps.js